(function () {
  'use strict';

  var TAB_STEP = 90;
  var TAB_OFFSET = 45;

  function init(root) {
    var tabs = root.querySelector('[data-vintage-tabs]');
    var slidesWrap = root.querySelector('[data-vintage-slides]');
    var prev = root.querySelector('[data-vintage-prev]');
    var next = root.querySelector('[data-vintage-next]');
    var fill = root.querySelector('[data-vintage-bar-fill]');

    if (!tabs || !slidesWrap) return;

    var tabButtons = Array.prototype.slice.call(tabs.querySelectorAll('[data-vintage-tab]'));
    var slides = Array.prototype.slice.call(slidesWrap.querySelectorAll('[data-vintage-slide]'));
    var count = slides.length;
    var index = 0;

    function updateTabsOffset() {
      tabs.style.transform = 'translateX(calc(50vw - ' + (index * TAB_STEP + TAB_OFFSET) + 'px))';
    }

    function updateBar() {
      if (!fill || count <= 1) return;
      var widthPct = 100 / count;
      var leftPct = (index / count) * 100;
      fill.style.width = widthPct + '%';
      fill.style.left = leftPct + '%';
    }

    function updateControls() {
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= count - 1;
    }

    function goTo(nextIndex) {
      if (nextIndex < 0 || nextIndex >= count || nextIndex === index) return;

      slides[index].classList.remove('is-active');
      slides[index].setAttribute('hidden', '');
      tabButtons[index].classList.remove('is-active');

      index = nextIndex;

      slides[index].classList.add('is-active');
      slides[index].removeAttribute('hidden');
      tabButtons[index].classList.add('is-active');

      updateTabsOffset();
      updateBar();
      updateControls();
    }

    tabButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        goTo(parseInt(button.getAttribute('data-vintage-tab'), 10));
      });
    });

    if (prev) {
      prev.addEventListener('click', function () {
        goTo(index - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        goTo(index + 1);
      });
    }

    window.addEventListener('resize', updateTabsOffset);

    updateTabsOffset();
    updateBar();
    updateControls();
  }

  function bootstrap() {
    document.querySelectorAll('[data-vintage-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
